import React, { useEffect, useMemo, useRef, useState } from 'react'

interface Props {
  strokeBackColor?: string
  strokeActiveColor?: string
  filledPercent: number
  isEven: boolean
}

function SvgTile(props: Props) {
  const { strokeBackColor = '#DADADA', strokeActiveColor = '#F9B22D', filledPercent, isEven } = props
  const pathRef = useRef<SVGPathElement>()
  const [isReady, setReady] = useState(false)

  useEffect(() => {
    setReady(true) // it works after render, when memo - before
  }, [])

  let strokeFilled: string = useMemo(() => {
    if (!isReady) return '0 1'
    if (filledPercent === 0) return '0 1'
    if (filledPercent === 100) return '0'

    if (!pathRef.current) return '0'
    let totalLength = pathRef.current.getTotalLength()
    let size = totalLength * (filledPercent / 100)

    // if (isEven) {
    //   // return `0 ${size}px ${totalLength - size}px`
    // }

    return `0 ${totalLength - size}px ${size}px`
  }, [filledPercent, isReady])

  // console.log('filledPercent', props.index, filledPercent, strokeFilled)

  return (
    <svg width="316" height="72" viewBox="0 0 316 72" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M276.912 8H279.5C294.964 8 307.5 20.536 307.5 36V36C307.5 51.464 294.964 64 279.5 64H8.5"
        stroke={strokeBackColor}
        strokeWidth="16"
      />
      <path
        d="M276.912 8H279.5C294.964 8 307.5 20.536 307.5 36V36C307.5 51.464 294.964 64 279.5 64H8.5"
        stroke={strokeActiveColor}
        strokeWidth="16"
        ref={pathRef as any}
        strokeDasharray={strokeFilled}
      />
      <rect
        x="296.694"
        y="60.3155"
        width="10"
        height="4"
        rx="2"
        transform="rotate(151.373 296.694 60.3155)"
        fill="white"
        fillOpacity="0.5"
      />
      <rect
        x="296.08"
        y="14.7612"
        width="10"
        height="4"
        rx="2"
        transform="rotate(-155.697 296.08 14.7612)"
        fill="white"
        fillOpacity="0.5"
      />
      <rect
        x="307.052"
        y="48.3358"
        width="10"
        height="4"
        rx="2"
        transform="rotate(129.09 307.052 48.3358)"
        fill="white"
        fillOpacity="0.5"
      />
      <rect
        x="308.694"
        y="32.1066"
        width="10"
        height="4"
        rx="2"
        transform="rotate(90 308.694 32.1066)"
        fill="white"
        fillOpacity="0.5"
      />
      <rect
        x="302.694"
        y="15.4463"
        width="10"
        height="4"
        rx="2"
        transform="rotate(60 302.694 15.4463)"
        fill="white"
        fillOpacity="0.5"
      />
      <rect x="168" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="272" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="116" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="220" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="64" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="13" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="155" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="259" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="103" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="207" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="51" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="142" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="246" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="90" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="194" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="38" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="129" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="233" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="77" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="181" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
      <rect x="25" y="62" width="10" height="4" rx="2" fill="white" fillOpacity="0.5" />
    </svg>
  )
}

export default SvgTile
